class Equipment {
	id = null;
	name = '';
	inventory_number = null;
	equipment_type_id = null;
	entry_date = null;
	write_off_date = null;
	classroom_name = null;
	write_off = false;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Equipment;
